export enum SupportedTokens {
    Aptos = 'aptos',
    Ethereum = 'ethereum',
    Polygon = 'polygon',
}

export enum CollectionChainParam {
    Aptos = <never>'aptos',
    Ethereum = <never>'ethereum',
    Polygon = <never>'polygon',
}

export enum CollectionChainType {
    Aptos = 'Aptos',
    Ethereum = 'Ethereum',
    Polygon = 'Polygon',
}

export const SupportedTokensToChain = {
    [SupportedTokens.Ethereum]: CollectionChainType.Ethereum,
    [SupportedTokens.Aptos]: CollectionChainType.Aptos,
    [SupportedTokens.Polygon]: CollectionChainType.Polygon,
};

export type ChainResponseItem<T> = { [Key in SupportedTokens]?: T };
